import * as React from 'react';

const OpenedSvg = () => (
  <svg width="11" height="7" viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.16163 0.148277C5.11172 0.181228 5.06438 0.21967 5.02044 0.263604C5.02044 0.263606 5.02045 0.263602 5.02044 0.263604L0.636376 4.64767C0.284904 4.99914 0.284904 5.56899 0.636376 5.92046C0.987848 6.27194 1.5577 6.27194 1.90917 5.92046L5.65684 2.17279L9.40451 5.92046C9.75598 6.27193 10.3258 6.27193 10.6773 5.92046C11.0288 5.56899 11.0288 4.99914 10.6773 4.64767L6.29324 0.263604C5.9857 -0.043934 5.51097 -0.0823762 5.16163 0.148277Z" fill="#020509" fillOpacity="0.6"/>
</svg>

  
);

export default OpenedSvg;
